export const breakpoints = {
    0: 'xs',
    640: 'sm',
    768: 'md',
    1024: 'lg',
    1280: 'xl',
    1536: '2xl',
  };
  